// extracted by mini-css-extract-plugin
export default {"header-image":"wave-loading_header-image__MoS4h","wave-text":"wave-loading_wave-text__M4WHE","wave":"wave-loading_wave__NADEo"};